<template>
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<div v-html="postsModal.title"></div> 
			</div>
			<div class="modal-body">
				<div v-html="postsModal.body"></div> 
			</div>
			<div class="modal-footer">
				<button class="btn btn-secondary" @click="handleClose">
					{{ this.$t("closeTxt") }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "MyComponentModal",
    props:['postsModal'],
	data: function (){
		return{
			dataObj:{
				title: '',
				body:''
			}
		}
	},
	methods:{
		handleClose(){
			this.$emit('close');
		}
	}
}
</script>